import React from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import Header from '../../../common/Header';
import { RootState } from '../../../../rootReducer';

export const RoleUndefined: React.FC = () => {
  // eslint-disable-next-line no-restricted-globals
  const goBackHandler = () => history.go(-1);
  // @ts-ignore
  const errorText = useSelector((state: RootState) => state.authModuleReducer.authReducer.errorText);

  // @ts-ignore
  return (
    <>
      <Header />
      {Object.keys(errorText).length !== 0 && errorText.error === undefined ? (
        <>
          <h3 className="m-5 text-center">
            Сервер не відповідає, спробуйте за декілька хвилин або зверніться в підтримку.
          </h3>
          <Button variant="danger" className="d-flex m-auto" onClick={goBackHandler}>
            <h3 className="text-white m-1">Назад</h3>
          </Button>
        </>
      ) : null}
      {Object.keys(errorText).length !== 0 && errorText.error !== undefined && errorText?.error?.status !== 403 ? (
        <>
          <h3 className="m-5 text-center">
            Сталась помилка, спробуйте за декілька хвилин або зверніться в підтримку. (код помилки{' '}
            {errorText?.error?.status})
          </h3>
          <Button variant="danger" className="d-flex m-auto" onClick={goBackHandler}>
            <h3 className="text-white m-1">Назад</h3>
          </Button>
        </>
      ) : null}
      {errorText && errorText?.error?.status === 403 ? (
        <>
          <h3 className="m-5 text-center">
            Пробачте, однак ми не знайшли вашу роль. Зверніться за допомогою до адміністратора. <br /> (Код{' '}
            {errorText?.error?.status}. {errorText?.error?.data.UserMessage})
          </h3>
          <Button variant="danger" className="d-flex m-auto" onClick={goBackHandler}>
            <h3 className="text-white m-1">Назад</h3>
          </Button>
        </>
      ) : null}
    </>
  );
};
